import { render, staticRenderFns } from "./IcreaRemarks.vue?vue&type=template&id=7497a7f7&"
import script from "./IcreaRemarks.vue?vue&type=script&lang=js&"
export * from "./IcreaRemarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports